import React, { Component } from "react";
import { Header, Image } from "semantic-ui-react";

const LOGO_URL = "https://mhcapp.mhc.asia/static/app_logo.png";

// The logo is served from an external host, so any outage there paints a
// broken-image placeholder on the first screen a user sees. Drop the element
// instead - the pages read fine without it.
//
// onError is not in semantic-ui-react's htmlImageProps, but it still reaches
// the <img>: with no children/dimmer/label/wrapped prop, Image renders as an
// actual <img> and spreads both of its prop partitions onto it. Wrapping this
// Image in one of those would silently stop the fallback working.
class AppLogo extends Component {
  state = { failed: false };

  handleError = () => {
    this.setState({ failed: true });
  };

  render() {
    if (this.state.failed) {
      return null;
    }
    return (
      <Header as="h1" textAlign="center">
        <Image
          src={LOGO_URL}
          size="huge"
          alt=""
          onError={this.handleError}
        />
      </Header>
    );
  }
}

export default AppLogo;
